module.exports = __webpack_public_path__ + "img/1de46594e634fcbc7eed9038eeb83a4b.png";